import { queryOptions } from "@tanstack/react-query";

import { environmentKeys } from "~/queries/environment/environment.keys";
import {
  fetchActivityCategories,
  fetchActivityKeywords,
  fetchEnvWeb,
} from "~/queries/environment/environment.service";

/**
 * Every env-service read. No `mutations` bucket — this data is published by config and
 * deploys, never by the app. `handshake` is a credential, so it stays out of the query key
 * and lives only in the `queryFn` closure.
 */
const environmentOptions = {
  queries: {
    activityCategories: ({
      handshake,
      locale,
    }: {
      handshake: string;
      locale: string;
    }) =>
      queryOptions({
        queryFn: () => fetchActivityCategories({ handshake, locale }),
        queryKey: environmentKeys.activityCategories(locale),
        staleTime: Infinity,
      }),
    activityKeywords: ({
      handshake,
      locale,
    }: {
      handshake: string;
      locale: string;
    }) =>
      queryOptions({
        queryFn: () => fetchActivityKeywords({ handshake, locale }),
        queryKey: environmentKeys.activityKeywords(locale),
        // Next's Data Cache is the freshness authority. `dehydrate` carries
        // `dataUpdatedAt` verbatim, so a finite staleTime under the hour-long ISR window
        // would refetch an unchanged list on nearly every page view.
        staleTime: Infinity,
      }),
    web: ({ handshake, locale }: { handshake: string; locale: string }) =>
      queryOptions({
        queryFn: () => fetchEnvWeb({ handshake, locale }),
        queryKey: environmentKeys.web(locale),
        // Same reasoning as `activityKeywords` above.
        staleTime: Infinity,
      }),
  },
};

export { environmentOptions };
